import { render } from "./RecoverForm.vue?vue&type=template&id=94a7cf46&scoped=true"
import script from "./RecoverForm.vue?vue&type=script&lang=js"
export * from "./RecoverForm.vue?vue&type=script&lang=js"

import "./RecoverForm.vue?vue&type=style&index=0&id=94a7cf46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94a7cf46"]])

export default __exports__